<template>
  <div class="page-content">
    <breadcrumb-index :items="breadcrumbs" />

    <div class="row g-3">
      <div class="col-lg-3">
        <div class="card">
          <div class="card-body py-2">
            <ul class="nav nav-pills flex-column">
              <li class="nav-item">
                <router-link to="/app/settings/profile" class="nav-link" active-class="active">
                  <vue-feather type="user" size="16" class="me-2" />
                  Profile
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/app/settings/security" class="nav-link" active-class="active">
                  <vue-feather type="shield" size="16" class="me-2" />
                  Security
                </router-link>
              </li>
              <li class="nav-item">
                <router-link to="/app/settings/app" class="nav-link" active-class="active">
                  <vue-feather type="settings" size="16" class="me-2" />
                  App Settings
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="col-lg-9">
        <div class="card">
          <div class="card-header">
            <h6 class="card-title mb-0">Application Settings</h6>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <h6 class="mb-3 small fw-semibold text-muted text-uppercase">General</h6>
              <div class="row g-3 mb-4">
                <div class="col-md-6">
                  <label class="form-label">App Name</label>
                  <input v-model="form.appName" type="text" class="form-control" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Support Email</label>
                  <input v-model="form.supportEmail" type="email" class="form-control" />
                </div>
              </div>

              <h6 class="mb-3 small fw-semibold text-muted text-uppercase">Exam Settings</h6>
              <div class="row g-3 mb-3">
                <div class="col-md-6">
                  <label class="form-label">Default Exam Duration (minutes)</label>
                  <input v-model.number="form.defaultExamDuration" type="number" class="form-control" min="1" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Default Passing Score (%)</label>
                  <input v-model.number="form.defaultPassingScore" type="number" class="form-control" min="0" max="100" />
                </div>
              </div>

              <div class="form-check mb-4">
                <input v-model="form.allowRetakes" type="checkbox" class="form-check-input" id="retakes" />
                <label class="form-check-label" for="retakes">Allow Exam Retakes by Default</label>
              </div>

              <h6 class="mb-3 small fw-semibold text-muted text-uppercase">Security</h6>
              <div class="form-check mb-3">
                <input v-model="form.require2FA" type="checkbox" class="form-check-input" id="require2fa" />
                <label class="form-check-label" for="require2fa">Require 2FA for All Users</label>
              </div>

              <div class="row g-3 mb-3">
                <div class="col-md-6">
                  <label class="form-label">Session Timeout (minutes)</label>
                  <input v-model.number="form.sessionTimeout" type="number" class="form-control" min="5" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">Max Login Attempts</label>
                  <input v-model.number="form.maxLoginAttempts" type="number" class="form-control" min="1" />
                </div>
              </div>

              <div v-if="error" class="alert alert-danger">{{ error }}</div>
              <div v-if="success" class="alert alert-success">Settings saved successfully!</div>

              <button type="submit" class="btn btn-primary btn-sm" :disabled="loading">
                <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                Save Settings
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import api from '@/services/api'

export default {
  name: 'AppSettings',
  setup() {
    const breadcrumbs = [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Settings' },
      { title: 'App Settings', active: true }
    ]

    const form = ref({
      appName: 'TestPal Admin',
      supportEmail: '',
      defaultExamDuration: 60,
      defaultPassingScore: 60,
      allowRetakes: true,
      require2FA: true,
      sessionTimeout: 30,
      maxLoginAttempts: 5
    })
    const loading = ref(false)
    const error = ref('')
    const success = ref(false)

    const fetchSettings = async () => {
      try {
        const response = await api.get('/v1/admin/settings/app')
        form.value = { ...form.value, ...response.data.settings }
      } catch (err) {
        console.error('Failed to fetch settings:', err)
      }
    }

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''
      success.value = false

      try {
        await api.put('/v1/admin/settings/app', form.value)
        success.value = true
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to save settings'
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchSettings)

    return { breadcrumbs, form, loading, error, success, handleSubmit }
  }
}
</script>
